import styled from 'styled-components'

const Capitalize = styled.span`
	text-transform: capitalize;
	display: inline-block;
`

export default Capitalize
